import React from 'react';
import moment from 'moment';

import VoiceCallIcon from '../../../assets/images/lucide_audio-lines.svg';
import './index.scss';

const BubbleVC = ({ data }) => {
  console.log('voice call data', data);
  const isVoicecall = ['VOICE_CALL', 'INCOMING_VOICE_CALL'].includes(data.initiatedFor);
  return (
    <div className="vc">
      <div className="vc__bubble">
        <img src={VoiceCallIcon} alt="play" />
        {/* <a href={message} target="_blank">Play the voicemail</a> */}
        {isVoicecall ? (<div className="vc__bubble_description">Incoming voice call</div>) : (
          <div className="vc__bubble_description">TrueLark (Voice) - Reminder for appt {data?.summary?.appointment_date && <div> on {moment(data?.summary?.appointment_date).format('MMM DD')}</div>}</div>)
        }
      </div>
    </div>
  );
};

export default BubbleVC;
